import React from "react";

const StatCard = ({ title, value, percentage, icon, iconColor, iconBg, borderColor, textColor }) => {
  return (
    <div
      className={`flex items-center justify-between bg-white shadow-md p-4 rounded-lg border-l-4 ${borderColor} hover:shadow-lg transition-all duration-300 w-full h-full`}
    >
      <div className="flex flex-col gap-2">
        <h3
          className="text-base font-semibold"
          style={{
            color: "#595C60",
            fontFamily: "Nunito Sans, sans-serif",
            fontWeight: 600,
          }}
        >
          {title}
        </h3>
        <p className="text-2xl font-bold text-gray-900">{value}</p>
        <p className={`text-sm ${textColor}`}>{percentage}</p>
      </div>
      <div className={`w-14 h-14 flex items-center justify-center rounded-full ${iconBg}`}>
        {React.cloneElement(icon, { className: `text-3xl ${iconColor}` })}
      </div>
    </div>
  );
};

export default StatCard;